import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { Table, Card, Row, Col, Select, notification } from "antd";

const { Option } = Select;

const defaultSortOrder = ["descend", "ascend", "descend"];
const StyledTable = styled(Table)`
  table {
    border-spacing: 0 10px !important;
  }
  .ant-table-tbody > tr > td {
    border: none;
    padding: 12px 16px;
  }
  .ant-table-row {
    border-radius: 10px !important;
    box-shadow: 1px 1px 10px #1c3faa1a !important;
  }
  .ant-table-column-sorters {
    padding: 0;
  }
  .ant-pagination-item,
  .ant-pagination-item-link {
    border-radius: 50% !important;
  }
  .ant-pagination-item-active {
    border: none;
    background: #2680eb;
    a {
      color: white !important;
    }
  }
`;

const EventPlayers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState("descend");
  const [tableData, setTableData] = useState(undefined);
  const [tableLoading, setTableLoading] = useState(false);
  const [allEvents, setAllEvents] = useState(null);
  const [eventName, setEventName] = useState(null);

  useEffect(() => {
    fetch("/api/Event/GetAllEvents")
      .then((res) => res.json())
      .then((data) => {
        setAllEvents(data);
      })
      .catch((err) => {
        console.log(err.response);
        notification.error({
          message: "Unable to fetch events",
          description: "",
        });
      });
  }, []);

  useEffect(() => {
    const api = "/api/EventPlayers/GetEventPlayers";
    const request = {
      method: "GET",
      params: { eventName: eventName },
    };
    setTableLoading(true);
    axios(api, request)
      .then((response) => {
        const { data } = response;
        setTableData(data);
        setTableLoading(false);
      })
      .catch((err) => {
        setTableLoading(false);
      });
  }, [eventName]);

  const CheckNull = (a, b, sortOrder) => {
    let initialItem = a ? a : sortOrder === "ascend" ? "z" : "a";
    let nextItem = b ? b : sortOrder === "ascend" ? "z" : "a";
    return [initialItem, nextItem];
  };

  const handleEventChange = (value) => {
    setEventName(value);
  };

  const columns = [
    {
      title: "Player Name",
      dataIndex: "playerName",
      key: "playerName",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.playerName, b.playerName, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Event",
      dataIndex: "eventName",
      key: "eventName",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.eventName, b.eventName, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Lucky Draw Number",
      dataIndex: "luckyDraw",
      key: "luckyDraw",
      sorter: (a, b) => a.luckyDraw - b.luckyDraw,
      sortDirections: defaultSortOrder,
    },
  ];

  return (
    <>
      <Card>
        <Row type="flex" justify="space-between">
          <Col>
            <h2>Event Players</h2>
          </Col>
          <Row justify="end">
            <Col>
              <Select
                placeholder="Select an event"
                onChange={handleEventChange}
                style={{ width: "200px" }}
                allowClear
              >
                {allEvents &&
                  allEvents.map((item, index) => (
                    <Option key={index} value={item.eventName}>
                      {item.eventName}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Row>
        </Row>
        <StyledTable
          loading={tableLoading}
          dataSource={tableData}
          columns={columns}
          pagination={{
            pageSize: 10,
            current: currentPage,
            total: tableData === undefined ? 0 : tableData.length,
            defaultCurrent: 1,
          }}
          onChange={(pagination, filters, sorter) => {
            setCurrentPage(pagination.current);
            if (sorter.order !== order) {
              setOrder(sorter.order);
              setCurrentPage(1);
            }
          }}
        />
      </Card>
    </>
  );
};

export default EventPlayers;
